import React from 'react';

/**
 * BatchHeader
 * Header cetak per-batch (satu untuk semua voucher yang dicetak sekaligus).
 * Muncul di atas grid/kartu voucher.
 *  - Baris 1: nama profile/paket (ex: "Paket 3 Jam - Rp. 5.000")
 *  - Baris 2: "Dibuat: DD-MM-YYYY HH:mm"
 *
 * Menggunakan inline style dgn `gridColumn: '1 / -1'` (untuk parent grid)
 * dan `flexBasis: '100%'` (untuk parent flex-wrap) supaya header selalu
 * memakai lebar penuh berapapun jenis parent container-nya.
 *
 * Props:
 *  - pkgName: string (nama profile/paket)
 *  - priceStr: string (harga terformat, misal "Rp. 5.000")
 *  - createdAt: string (sudah diformat "DD-MM-YYYY HH:mm")
 *  - count: number (jumlah voucher)
 */
const BatchHeader = ({ pkgName = '', priceStr = '', createdAt = '', count = 0 }) => {
  const title = [pkgName, priceStr].filter(Boolean).join(' - ');
  return (
    <div
      className="print-batch-header"
      data-testid="voucher-batch-header"
      style={{
        width: '100%',
        gridColumn: '1 / -1',
        flexBasis: '100%',
        padding: '2mm 4mm',
        marginBottom: '2mm',
        background: '#ffffff',
        borderBottom: '1.2px solid #111827',
        boxSizing: 'border-box',
        fontFamily: 'Arial, sans-serif',
        color: '#111827',
        pageBreakInside: 'avoid',
        breakInside: 'avoid',
      }}
    >
      <div
        style={{
          fontSize: '11pt',
          fontWeight: 900,
          textAlign: 'center',
          letterSpacing: '0.3mm',
          lineHeight: 1.2,
        }}
      >
        {title || 'Voucher Hotspot'}
      </div>
      <div
        style={{
          fontSize: '7.5pt',
          fontWeight: 600,
          textAlign: 'center',
          marginTop: '0.6mm',
          color: '#374151',
          letterSpacing: '0.15mm',
        }}
      >
        Dibuat: {createdAt}
        {count ? `  •  ${count} voucher` : ''}
      </div>
    </div>
  );
};

export default BatchHeader;
